// jQuery on ready.
$(function () {
  
  // Enables tooltip on all bootstrap tooltip.
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  const tooltipList = [...tooltipTriggerList].map(el => new bootstrap.Tooltip(el));

  $('a[href="#top-of-page"]').on("click", function (event) {
    var target = $(this.getAttribute("href"));
    if (target.length) {
      event.preventDefault();
      $("html, body").stop().animate(
        {
          scrollTop: target.offset().top,
        },
        450
      );
    }
  });

  const topbtn = document.querySelector('.topbutton');

  if (topbtn) {
    window.addEventListener('scroll', () => {
      topbtn.classList.toggle('visible', window.scrollY > 300);
    });

    topbtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  $(".screen-reader-shortcut").attr("tabindex", "0");

  $("#tools").addClass("tools-visible");


  function hexToRgb(hex) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',');
    }
  }

  $('.wp-block-cover.has-background-dim, .wp-block-columns.has-background-dim, .wp-block-column.has-background-dim').each(function () {
    $background = jQuery(this).css('background-color').valueOf();
    if (jQuery(this).hasClass('wp-block-cover')) {
      jQuery(this).css('background-color', $background);
    }
    else {
      $background = $background.slice(0, -1);
      if (jQuery(this).hasClass('has-background-dim-10')) {
        $background = $background + ", .1)";
      }
      if (jQuery(this).hasClass('has-background-dim-20')) {
        $background = $background + ", .2)";
      }
      if (jQuery(this).hasClass('has-background-dim-30')) {
        $background = $background + ", .3)";
      }
      if (jQuery(this).hasClass('has-background-dim-40')) {
        $background = $background + ", .4)";
      }
      if (jQuery(this).hasClass('has-background-dim-50')) {
        $background = $background + ", .5)";
      }
      if (jQuery(this).hasClass('has-background-dim-60')) {
        $background = $background + ", .6)";
      }
      if (jQuery(this).hasClass('has-background-dim-70')) {
        $background = $background + ", .7)";
      }
      if (jQuery(this).hasClass('has-background-dim-80')) {
        $background = $background + ", .8)";
      }
      if (jQuery(this).hasClass('has-background-dim-90')) {
        $background = $background + ", .9)";
      }
      $background = $background.replace('rgb', 'rgba');
      jQuery(this).css('background-color', $background);
    }
  });

  //Carousel Overlay Opacity
  $('tui-carousel-slide').each(function () {
    $backgroundAttr = jQuery(this).attr('overlay');
    jQuery(this).css('background-color', $backgroundAttr);
    $background = jQuery(this).css('background-color').slice(0, -1);
    $attr = $(this).attr('dim');
    if (typeof $attr !== 'undefined' && $attr !== false) {
      if ($attr == 10) {
        $background = $background + ", .1)";
      }
      if ($attr == 20) {
        $background = $background + ", .2)";
      }
      if ($attr == 30) {
        $background = $background + ", .3)";
      }
      if ($attr == 40) {
        $background = $background + ", .4)";
      }
      if ($attr == 50) {
        $background = $background + ", .5)";
      }
      if ($attr == 60) {
        $background = $background + ", .6)";
      }
      if ($attr == 70) {
        $background = $background + ", .7)";
      }
      if ($attr == 80) {
        $background = $background + ", .8)";
      }
      if ($attr == 90) {
        $background = $background + ", .9)";
      }
      if ($attr == 0) {
        $background = "";
      }
      $background = $background.replace('rgb', 'rgba');
    }
    jQuery(this).css('background-color', $background);
  });

  // Prevent automatic external-link icons on linked images.
  $("a img")
    .parent("a")
    .not(".btn-arrow")
    .addClass("no-icon");

  // Prevent automatic external-link icons on anchors without href,
  // except custom arrow buttons.
  $("a:not([href]):not([tabindex]):not(.btn-arrow)").addClass("no-icon");

  // Remove no-icon if another rule previously added it.
  $("a.btn-arrow").removeClass("no-icon");

  // const siteUrl = window.wp_site ? window.wp_site.getUrl : "";
  // const hostURL = window.location.host.indexOf(".sandia.gov") > 0 ? window.location.host : siteUrl;

  // $( 'a:not( [href^="' + hostURL + '"] ):not([href*=".sandia.gov"]):not([href*="/app/uploads/"]):not([href*="javascript:void(0);"])').addClass("external-link");

  const siteArray = [
    'https://communicate.sandia.gov',
    'https://communicate.test',
    'https://communicate-dev.sandia.gov',
    'https://communicate-qual.sandia.gov',
    'https://wp.sandia.gov',
    'https://wp.test',
    'https://wp-dev.sandia.gov',
    'https://wp-qual.sandia.gov',
    'https://scnweb.sandia.gov',
    'https://scnweb-qual.sandia.gov',
    'https://scnwp-dev.sandia.gov',
    'https://www.sandia.gov',
    'https://www-qual.sandia.gov',
    'https://emp.test',
    'https://www-dev.sandia.gov',
    'https://sandia.gov',
    'https://localhost:3333',
    // 'https://executive-newsletters.sandia.test'
  ];

  function getHostNameAndFirstPath(url) {
    const match = url.match(/^(https?:\/\/[^\/]+)\/([^\/]+)?/);
    if (match) {
      let result = match[1];
      if (match[2]) {
        // result += '/' + match[2];
        result += '';
      }
      return result;
    } else {
      return "";
    }
  }

  // To Do: This fetch will get subsites rather the pages as it does currently. Consider moving to sandia core plugins 3/12/24
  // function fetchPages(restApiEndpoint) {
  //   let allPages = [];
  //   fetch(restApiEndpoint)
  //   .then(response => {
  //     if (!response.ok) {
  //       throw new Error('Network response was not ok ', response);
  //     }
  //     return response.json();
  //   })
  //   .then(pages => {
  //     pages.forEach(page => {
  //       allPages.push(page.title.rendered);
  //     })
  //   })
  //   .catch(e => {
  //     console.log('Error fetching pages: ', e );
  //   })

  //   return allPages;
  // }

  function isValidUrl(theUrl) {
    try {
      new URL(theUrl);
      return true;
    } catch (e) {
      return false;
    }
  }

  const currentSite = getHostNameAndFirstPath(window.location.href);
  const currentTrimmed = currentSite.replace(/\/$/, "");
  const urlObj = new URL(currentSite);
  const baseUrl = urlObj.origin;
  const isMultisite = siteArray.includes(baseUrl);
  let siteTitle = "";

  //just the path name if it exists
  if (urlObj.pathname !== "/" && urlObj.pathname !== "") {
    let pathComponents = urlObj.pathname.split("/");
    siteTitle = pathComponents[1];
  }

  // To Do: create a new endpoint using sites then compare on a site by site bases. Consider moving to sandia core plugins 3/12/24
  // const restApiEndpoint = ( isMultisite ) ? `${currentSite}/wp-json/wp/v2/pages` : `${baseUrl}/wp-json/wp/v2/pages`;
  // const restApiEndpointPosts = ( isMultisite ) ? `${currentSite}/wp-json/wp/v2/posts` : `${baseUrl}/wp-json/wp/v2/posts`;

  // const pageArray = fetchPages(restApiEndpoint);
  // const postsArray = fetchPages(restApiEndpointPosts);

  // const combinedTitles = [...pageArray, ...postsArray];

  function addExternalLinkIcon(link) {
    const iconSpan = document.createElement('span');
    iconSpan.classList.add('external-link');
    link.appendChild(iconSpan);
    // Security and privacy: prevent the new page from accessing the window.opener property and redirecting to a malicious website (Reverse tabnabbing)
    // Also, don't send referer [sic] heading to external website
    link.setAttribute('rel', 'noopener noreferrer');
    // If desired, open external link in a new window. Currently used on WP-MS.
    // Use thunderberg_open_external_links_in_a_new_window php filter to turn this on.
    if (thunderbergExternalLinkSettings?.openInNewWindow) {
      link.setAttribute('target', '_blank');
    }
  }


  const fileExcludeList = ['doc', 'docs', 'docx', 'ppt', 'xls', 'pdf', 'txt', 'jpg', 'png', 'gif', 'svg', 'mp3', 'm4a', 'wma', 'wav', 'aif', 'mp4', 'mov', 'avi', 'flv', 'mpg', 'wmv', 'gitlab', 'zip', 'gz', 'tar', '7z', 'macos', 'linux', 'src', 'suno'];

  const links = document.querySelectorAll('a');

  links.forEach(function (link) {
    if (link.href && isValidUrl(link)) {
      const theLink = link.href;
      const hashCheck = theLink.charAt(theLink.length - 1);

      // Check if the link ends with a hash (#)
      if (hashCheck === "#") {
        return; // Skip links that end with a hash
      }

      // Check if the link is a staffer main link or has the no-icon class
      if (link.classList.contains('staffer-main-link') || link.classList.contains('no-icon')) {
        return; // Skip staffer main links
      }

      // Check if the link is inside a heading (h1, h2, h3, h4, h5, h6) or the Social Share Buttons block
      if (link.closest('h1, h2, h3, h4, h5, h6, .snl-social-share-btns') !== null) {
        return; // Skip links inside headings
      }

      // Check if the link has a file extension that should be excluded
      const lowerLink = theLink.toLowerCase();
      if (fileExcludeList.some(ext => lowerLink.includes(ext))) {
        return; // Skip links with excluded file extensions
      }

      const siteWithPath = getHostNameAndFirstPath(theLink);
      const sitePathTrimmed = siteWithPath.replace(/\/$/, "");

      if (isMultisite) {
        // To Do: compare the sites by subsite and not posts and pages. This also addresses custom post types. Consider moving to sandia core plugins 3/12/24
        // if (sitePathTrimmed !== currentSite && !combinedTitles.includes(siteTitle)) {
        if (sitePathTrimmed !== currentTrimmed) {
          if (!theLink.includes(baseUrl)) {
            addExternalLinkIcon(link); // Add external link icon
          }
        } else {
          if (sitePathTrimmed !== currentTrimmed) {
            addExternalLinkIcon(link); // Add external link icon
          }
        }
      } else {
        const linkObj = new URL(theLink);
        const linkbaseURL = linkObj.origin;

        if (linkbaseURL !== baseUrl) {
          addExternalLinkIcon(link); // Add external link icon
        }
      }
    }
  });

  setTimeout(repairLinks, 2000);
});
// END on ready.

function repairLinks() {
  $("a[onclick]").each(function (index) {
    if ($(this).attr("rel") !== undefined) {
    } else {
      if (/(wp\.sandia\.gov.*)|(www\.sandia\.gov.*)/.test($(this).attr("href"))) {
        $(this).removeAttr('onclick');
      }
    }
  });
}

// This fixes the inline style issue brought in from the corp header
$(document).ready(function (e) {
  $('#snl-global-header #snl-global-header-corpNav li a').css('padding', '12px');
})


if (navigator.userAgent.match(/Trident\/7\./)) {
  // if IE
  $("body").on("mousewheel", function () {
    // remove default behavior
    event.preventDefault();

    //scroll without smoothing
    var wheelDelta = event.wheelDelta;
    var currentScrollPosition = window.pageYOffset;
    window.scrollTo(0, currentScrollPosition - wheelDelta);
  });
}

//disable rightclick on podcast lists
$(document).ready(function (e) {
  $(".custom-podcast-shortcode, .custom-podcast").on("contextmenu", function (e) {
    e.preventDefault();
  })
})

$(document).ready(function () {
  $(".snl-playback-control").change(function () {
    const playbackRate = $(this).val();
    const associtedAudio = $(this).closest('.snl-audio-wrapper').find('.podcast-player')[0];
    associtedAudio.playbackRate = playbackRate;
  })
})

// HR Homepage Dropdown Fix.
$(function () {
  $('.wp-block-navigation').parents('.wp-block-cover').css('overflow', 'visible');
  $('.wp-block-navigation').parents('body').find('.wp-block-group, .wp-block-columns').each(function () {
    $(this).css('position', 'relative');
    $(this).css('z-index', '1');
  })
});

$(function () {
  const PAUSE_SVG = `
    <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <path d="M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96
               c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5
               -21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48
               48h96c26.5 0 48-21.5 48-48z"/>
    </svg>`.trim();

  const PLAY_SVG = `
    <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5
               40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"/>
    </svg>`.trim();

  $('body').on('click', '.carousel-toggle', function () {
    const btn = $(this);
    const carouselEl = btn.closest('.carousel.slide').get(0);
    // use the UMD global, not the ESM import
    const carousel = window.bootstrap.Carousel.getOrCreateInstance(carouselEl);

    const iconContainer = btn.find('.pause-play-icon');
    const srLabel = btn.find('.sr-only');
    const nowPaused = btn.toggleClass('paused').hasClass('paused');

    if (nowPaused) {
      console.log('paused');
      carousel.pause();
      iconContainer.html(PLAY_SVG);
      srLabel.text('Start Animation');
    } else {
      carousel.cycle();
      iconContainer.html(PAUSE_SVG);
      srLabel.text('Pause Animation');
    }
  });

  jQuery('.carousel.slide.autoplay-false').toggleClass('autoplay-false').find('.carousel-toggle').trigger('click');
});

// This rewires the categories list dropdown block to work with our CSP
document.addEventListener('change', function (event) {
	const dropdown = event.target.closest('.wp-block-categories-dropdown select[name="cat"]');

	if (!dropdown) {
		return;
	}

	const selectedOption = dropdown.options[dropdown.selectedIndex];

	if (!selectedOption) {
		return;
	}

	const categoryUrl = selectedOption.getAttribute('data-category-url');

	if (!categoryUrl) {
		console.warn('Category dropdown missing data-category-url attribute.');
		return;
	}

	window.location.href = categoryUrl;
});